import { render, staticRenderFns } from "./WorldMap.vue?vue&type=template&id=d2f5a698&scoped=true&"
import script from "./WorldMap.vue?vue&type=script&lang=js&"
export * from "./WorldMap.vue?vue&type=script&lang=js&"
import style0 from "./WorldMap.vue?vue&type=style&index=0&id=d2f5a698&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f5a698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2f5a698')) {
      api.createRecord('d2f5a698', component.options)
    } else {
      api.reload('d2f5a698', component.options)
    }
    module.hot.accept("./WorldMap.vue?vue&type=template&id=d2f5a698&scoped=true&", function () {
      api.rerender('d2f5a698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/WorldMap.vue"
export default component.exports